import { create } from 'zustand';

export interface CanvasAwarenessContext {
  module: 'canvas';
  projectId: number;
  mode?: 'drawing' | 'html' | 'pixel';
  viewport?: { x: number; y: number; zoom: number } | { scrollTop: number; scrollLeft: number };
  selectedElementIds?: string[];
  cursor?: { x: number; y: number };
}

interface CanvasContextStore {
  context: CanvasAwarenessContext | null;
  setCanvasContext: (ctx: CanvasAwarenessContext | null) => void;
  updateCanvasContext: (patch: Partial<CanvasAwarenessContext>) => void;
  clearCanvasContext: () => void;
}

/**
 * Global store for canvas awareness. Populated by CanvasEditorPage so that
 * AIChatWidget can inject the active canvas context into `ai:chat` payloads.
 */
export const useCanvasContextStore = create<CanvasContextStore>((set, get) => ({
  context: null,
  setCanvasContext: (ctx) => set({ context: ctx }),
  updateCanvasContext: (patch) => {
    const cur = get().context;
    if (!cur) return;
    set({ context: { ...cur, ...patch } });
  },
  clearCanvasContext: () => set({ context: null }),
}));
